"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCoreTimelineExportSlice = void 0;
const _api_1 = require("../../../api/index.js");
const xuder_1 = require("@sonar-software/xuder");
exports.postCoreTimelineExportSlice = (0, xuder_1.createPostAsyncSlice)({
    name: 'CoreTimelineExport',
    receive: true,
    request: true,
    requestHandler: _api_1.postTimelineExportStart,
    retainDataOnRequest: false,
    yieldType: xuder_1.SagaYieldType.Every
});
//# sourceMappingURL=post.js.map